import styled from "styled-components";

export const Container = styled("div")`
  display: grid;
  grid-auto-rows: 1fr;

  border-radius: 20px;
  background-color: #0D0D0F;
  padding: 0.5rem 1.2rem;
`;

export const InfoSection = styled("div")`
  color: #FFFFFF;
  display: flex;
  gap: 1.2rem;
  align-items: center;

  & + & {
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    padding-top: 1.2rem;
  }
`;
